import * as Types from 'src/actions/project/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetProjectAttempt extends Action {
  type: Types.GET_PROJECT_ATTEMPT;
}

export interface GetProjectSuccess extends Action {
  type: Types.GET_PROJECT_SUCCESS;
  payload: Project;
}

export interface GetProjectFailure extends Action {
  type: Types.GET_PROJECT_FAILURE;
  payload: {};
}

export type GetProjectAction = GetProjectAttempt | GetProjectSuccess | GetProjectFailure;

export interface GetProjectThunk extends ThunkAction<Promise<GetProjectAction>, RootState, string> {
}

export const getProjectAttempt: ActionCreator<GetProjectAttempt> = () => (
  {
    type: Types.GET_PROJECT_ATTEMPT
  }
);

export const getProjectSuccess: ActionCreator<GetProjectSuccess> = (
  project: Project) => (
  {
    type: Types.GET_PROJECT_SUCCESS,
    payload: project
  }
);

export const getProjectFailure: ActionCreator<GetProjectFailure> = (error: {}) => (
  {
    type: Types.GET_PROJECT_FAILURE,
    payload: error
  }
);

export const getProject: ActionCreator<GetProjectThunk> =
  (id: string): GetProjectThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetProjectAction> => {
      dispatch(getProjectAttempt());

      return ApiClient.project.get(id)
        .then((response: AxiosResponse<Project>): GetProjectSuccess => {
          const project: Project = response.data;
          return dispatch(getProjectSuccess(project));
        }).catch((e: { response: { data: { error: {} } } }): GetProjectFailure => {
          const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(getProjectFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/get/GetProject.actions.tsx